/**
 * API Client - Convenience wrapper around apiRequest
 *
 * Provides HTTP method helpers (get, post, put, patch, delete) that
 * automatically handle auth headers, workspace ID, and error handling.
 *
 * Usage:
 *   import { apiClient } from '../services/apiClient';
 *   const data = await apiClient.get<UserProfile>('/users/me');
 *   const order = await apiClient.post<Order>('/orders', { items: [...] });
 */

import { apiRequest } from './api/core';

export const apiClient = {
  get: <T = unknown>(endpoint: string) =>
    apiRequest<T>(endpoint),

  post: <T = unknown>(endpoint: string, data?: unknown) =>
    apiRequest<T>(endpoint, {
      method: 'POST',
      body: data !== undefined ? JSON.stringify(data) : undefined,
    }),

  put: <T = unknown>(endpoint: string, data?: unknown) =>
    apiRequest<T>(endpoint, {
      method: 'PUT',
      body: data !== undefined ? JSON.stringify(data) : undefined,
    }),

  patch: <T = unknown>(endpoint: string, data?: unknown) =>
    apiRequest<T>(endpoint, {
      method: 'PATCH',
      body: data !== undefined ? JSON.stringify(data) : undefined,
    }),

  delete: <T = unknown>(endpoint: string, data?: unknown) =>
    apiRequest<T>(endpoint, {
      method: 'DELETE',
      body: data !== undefined ? JSON.stringify(data) : undefined,
    }),
};

export default apiClient;
